export default [
  {
    path: '/pagos-programas',
    name: 'pagos-programas',
    component: () => import('@/views/pagos/layouts/ProgramasLayout.vue'),
  },
  {
    path: '/pagos-sede-universidad',
    name: 'pagos-sede-universidad',
    component: () => import('@/views/pagos/layouts/SedeUniversidadLayout.vue'),
  },
  {
    path: '/pagos-programa-universidad-sede',
    name: 'pagos-programa-universidad-sede',
    component: () => import('@/views/pagos/layouts/ProgramaUniversidadSedeLayout.vue'),
  },
  {
    path: '/pagos-programa-universidad-nacional',
    name: 'pagos-programa-universidad-nacional',
    component: () => import('@/views/pagos/layouts/ProgramaUniversidadNacionalLayout.vue'),
  },
  {
    path: '/pagos-solicitudes',
    name: 'pagos-solicitudes',
    component: () => import('@/views/pagos/layouts/SolicitudesPagosLayout.vue'),
  },
  {
    path: '/pagos-solicitudes-agrupados',
    name: 'pagos-solicitudes-agrupados',
    component: () => import('@/views/pagos/layouts/SolicitudesPagosAgrupadosLayout.vue'),
  },
  {
    path: '/pagos-conceptos',
    name: 'pagos-conceptos',
    component: () => import('@/views/pagos/layouts/ConceptosLayout.vue'),
  },
  {
    path: '/pagos-instituciones',
    name: 'pagos-instituciones',
    component: () => import('@/views/pagos/layouts/InstitucionesLayout.vue'),
  },
  {
    path: '/pagos-solicitudes-inscripciones',
    name: 'pagos-solicitudes-inscripciones',
    component: () => import('@/views/pagos/layouts/SolicitudesInscripcionesLayout.vue'),
  },
  {
    path: '/pagos-inscripciones-programas-universidad',
    name: 'pagos-inscripciones-programas-universidad',
    component: () => import('@/views/pagos/layouts/InscripcionesProgramasUniversidadLayout.vue'),
  },
];
